import { ArtistPortalSyncStatus } from 'fym-shared/src/smartlinks/artistPortals';
import { ServiceConnectionStatus } from 'fym-shared/src/smartlinks/catalog';
import { MusicAPIIntegrationID } from 'fym-shared/src/music-services/ids';
import { ServiceConnection } from '../../../../redux/api/fymAPI.types';

/** The states of the SoundCloud card (design a2). */
export type SoundCloudCardState = 'notConnected' | 'connecting' | 'firstRead' | 'connected' | 'reconnect' | 'failed';

/** True for the SoundCloud card of the deck once it is built (no early-access row). */
export function isSoundCloudCard(connection: ServiceConnection): boolean {
  return connection.integrationType === MusicAPIIntegrationID.SoundCloud && !connection.earlyAccess;
}

/**
 * The state of the card. `isConnecting`: the click left for SoundCloud (state 2). `connectFailed`:
 * the return page came back with an error (state 6, until the next try). A stored login with no
 * read yet is the first read (state 3); `artistPortal.synced` ends it.
 */
export function soundCloudCardState(
  connection: ServiceConnection,
  { isConnecting, connectFailed }: { isConnecting: boolean; connectFailed: boolean }
): SoundCloudCardState {
  if (connection.status === ServiceConnectionStatus.expired) {
    return isConnecting ? 'connecting' : 'reconnect';
  }
  if (connection.status === ServiceConnectionStatus.connected) {
    const isReading =
      connection.syncStatus === ArtistPortalSyncStatus.queued ||
      connection.syncStatus === ArtistPortalSyncStatus.running;
    return connection.lastSyncAt === null || (isReading && connection.syncedThrough === null)
      ? 'firstRead'
      : 'connected';
  }
  if (isConnecting) {
    return 'connecting';
  }
  return connectFailed ? 'failed' : 'notConnected';
}
